import { useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationError } from "../components/Utils/Notification";
import { validateMagicToken } from "../api/auth";
import { UserContext } from "../context/UserContext";

export function useMagicLogin() {
  const authCtx = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const run = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get("magicToken");

      if (token) {
        const result = await validateMagicToken(token);
        if (result?.isOk && result?.data?.access_token) {
          const accessToken = result.data.access_token;
          const expirationTime = new Date(
            new Date().getTime() + 1000 * 60 * 60 * 24 * 7,
          );
          authCtx.login(accessToken, expirationTime);

          // Clean URL
          const searchWithoutToken = location.search
            .replace(/([&?])magicToken=[^&]+/, "")
            .replace(/^&/, "?");
          navigate(location.pathname + searchWithoutToken);
        } else {
          NotificationError("Link wygasł lub jest nieprawidłowy.");
        }
      }
    };

    run();
    // eslint-disable-next-line
  }, [location.search, authCtx]);
}
